import React from 'react';
import { get, post, put, del,postMultipart } from '../../Utility/Http';
import { login, coachRegisterApiGet,getTeamListApiGet ,forgotPasswordApiGet,imageUploadApiPost,getCountyApiGet} from '../Model/LoginModel';
import Config from '../../Utility/Config';

export const coachLoginApi = async (data) => {
    const response = await post(`${Config.EXTENDED_URL}user/coach-login`, data, null);
    return login(response);
};
export const sponsorLoginApi = async (data) => {
    const response = await post(`${Config.EXTENDED_URL}user/login`, data, null);
    return login(response);
};
export const adminLoginApi = async (data) => {
    const response = await post(`${Config.EXTENDED_URL}admin/login`, data, null);
    return login(response);
};
export const coachRegisterApi = async (data) => {
    const response = await post(`${Config.EXTENDED_URL}user/register`, data, null);
    return coachRegisterApiGet(response);
};
export const getTeamListApi = async () => {
    console.log(process.env.EXTENDED_URL);
    const response = await get(`${Config.EXTENDED_URL}user/team-name`, null);
    return getTeamListApiGet(response);
};
export const forgotPasswordApi = async (data) => {
    const response = await post(`${Config.EXTENDED_URL}user/coach-forget-password-otp`, data);
    return forgotPasswordApiGet(response);
};
export const imageUploadApi = async (data) => {
    const response = await postMultipart(`${Config.EXTENDED_URL}upload-image`, data);
    return imageUploadApiPost(response);
};
export const getCountryApi = async (data) => {
    const response = await get(`${Config.EXTENDED_URL}countries`, data);
    return getCountyApiGet(response);
};
